import React from 'react';
import { getAssetPath } from 'utils/asset-utils';
import { SegmentFilter } from 'utils/gqlReactTypings.generated.d';

export interface SegmentDisplayInfo {
  icon: string;
  hoverIcon: string;
  title: string;
  style?: React.CSSProperties;
}

export enum DefinedSubcuisines {
  NORTH_INDIAN = 'NORTH_INDIAN',
  SOUTH_INDIAN = 'SOUTH_INDIAN',
  BENGALI = 'BENGALI',
}

export const SegmentFilterDisplayInfo: { [filter in SegmentFilter | DefinedSubcuisines]?: SegmentDisplayInfo } = {
  [SegmentFilter.All]: {
    icon: getAssetPath('/icons/static/svg/All-Cuisine-Icon_Globe_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/All-Cuisine-Icon_Globe_200x200px_Colour-HOVER.svg'),
    title: 'All',
  },
  [SegmentFilter.Indian]: {
    icon: getAssetPath('/icons/static/svg/Indian-Cuisine-Icon_Curry-Pot_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Indian-Cuisine-Icon_Curry-Pot_200x200px_Colour-HOVER.svg'),
    title: 'Indian',
  },
  SOUTH_INDIAN: {
    icon: getAssetPath('/icons/static/svg/South-Indian-Cuisine-Icon_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/South-Indian-Cuisine-Icon_200x200px_Colour-HOVER.svg'),
    title: 'South Indian',
  },
  NORTH_INDIAN: {
    icon: getAssetPath('/icons/static/svg/North-Indian-Cuisine-Icon_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/North-Indian-Cuisine-Icon_200x200px_Colour-HOVER.svg'),
    title: 'North Indian',
  },
  BENGALI: {
    icon: getAssetPath('/icons/static/svg/Bengali-Cuisine-Icon_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Bengali-Cuisine-Icon_200x200px_Colour-HOVER.svg'),
    title: 'Bengali',
  },
  [SegmentFilter.Chinese]: {
    icon: getAssetPath('/icons/static/svg/Chinese-Cuisine-Icon_Spring-Rolls_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Chinese-Cuisine-Icon_Spring-Rolls_200x200px_Colour-HOVER.svg'),
    title: 'Chinese',
  },
  [SegmentFilter.MiddleEastern]: {
    icon: getAssetPath('/icons/static/svg/Middle-East-Cuisine-Icon_Kebob-Sticks_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Middle-East-Cuisine-Icon_Kebob-Sticks_200x200px_Colour-HOVER.svg'),
    title: 'Middle Eastern',
  },
  [SegmentFilter.Nepalese]: {
    icon: getAssetPath('/icons/static/svg/Nepalese-Cuisine-Icon_Momo_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Nepalese-Cuisine-Icon_Momo_200x200px_Colour-HOVER.svg'),
    title: 'Nepalese',
  },
  [SegmentFilter.Mexican]: {
    icon: getAssetPath('/icons/static/svg/Mexican-Cuisine-Icon_Tacos_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Mexican-Cuisine-Icon_Tacos_200x200px_Colour-HOVER.svg'),
    title: 'Mexican',
  },
  [SegmentFilter.Korean]: {
    icon: getAssetPath('/icons/static/svg/Korean-Cuisine-Icon_KBBQ_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Korean-Cuisine-Icon_KBBQ_200x200px_Colour-HOVER.svg'),
    title: 'Korean',
  },
  [SegmentFilter.African]: {
    icon: getAssetPath('/icons/static/svg/African-Cuisine-Icon_Injera_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/African-Cuisine-Icon_Injera_200x200px_Colour-HOVER.svg'),
    title: 'African',
  },
  [SegmentFilter.Southern]: {
    icon: getAssetPath('/icons/static/svg/Southern-US-Cuisine-Icon_Fried-Chicken-Ribs_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Southern-US-Cuisine-Icon_Fried-Chicken-Ribs_200x200px_Colour-HOVER.svg'),
    title: 'Southern',
  },
  [SegmentFilter.Pakistani]: {
    icon: getAssetPath('/icons/static/svg/Pakistani-Cuisine-Icon_Samosa_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Pakistani-Cuisine-Icon_Samosa_200x200px_Colour-HOVER.svg'),
    title: 'Pakistani',
  },
  [SegmentFilter.Mediterranean]: {
    icon: getAssetPath('/icons/static/svg/Mediterranean-Cuisine-Icon_Greek-Salad-Falafels_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath(
      '/icons/hover/svg/Mediterranean-Cuisine-Icon_Greek-Salad-Falafels_200x200px_Colour-HOVER.svg'
    ),
    title: 'Mediterranean',
  },
  [SegmentFilter.Caribbean]: {
    icon: getAssetPath('/icons/static/svg/Brazilian-Cuisine-Icon_Carved-Meat_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Brazilian-Cuisine-Icon_Carved-Meat_200x200px_Colour-HOVER.svg'),
    title: 'Caribbean',
  },
  [SegmentFilter.LatinAmerican]: {
    icon: getAssetPath('/icons/static/svg/Latin-American-Cuisine-Icon_Rice-Beans_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Latin-American-Cuisine-Icon_Rice-Beans_200x200px_Colour-HOVER.svg'),
    title: 'Latin American',
  },
  [SegmentFilter.Italian]: {
    icon: getAssetPath('/icons/static/svg/Italian-Cuisine-Icon_Spaghetti-Bolognese_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Italian-Cuisine-Icon_Spaghetti-Bolognese_200x200px_Colour-HOVER.svg'),
    title: 'Italian',
  },
  [SegmentFilter.Japanese]: {
    icon: getAssetPath('/icons/static/svg/Japanese-Cuisine-Icon_Sushi_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Japanese-Cuisine-Icon_Sushi_200x200px_Colour-HOVER.svg'),
    title: 'Japanese',
  },
  [SegmentFilter.SoutheastAsian]: {
    icon: getAssetPath('/icons/static/svg/Thai-Cuisine-Icon_Pad-Thai_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Thai-Cuisine-Icon_Pad-Thai_200x200px_Colour-HOVER.svg'),
    title: 'Southeast Asian',
  },
  [SegmentFilter.American]: {
    icon: getAssetPath('/icons/static/svg/american-static-200.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/american-dynamic-200.svg'),
    style: { padding: '8px' },
    title: 'American',
  },
  [SegmentFilter.BakedGoods]: {
    icon: getAssetPath('/icons/static/svg/Specialty-Icon-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/Specialty-Icon-HOVER.svg'),
    title: 'Baked Goods',
    style: { padding: '6px' },
  },
  [SegmentFilter.More]: {
    icon: getAssetPath('/icons/static/svg/More-Cuisine-Icon_Pan-Ingredients_200x200px_Colour-STATIC.svg'),
    hoverIcon: getAssetPath('/icons/hover/svg/More-Cuisine-Icon_Pan-Ingredients_200x200px_Colour-HOVER.svg'),
    title: 'More Cuisines',
  }, // Keep at the end
};
